// extracted by mini-css-extract-plugin
export default {"settingsContainer":"SettingsIcon_settingsContainer__1Jzqb"};